module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"head":{"meta":{"description":"TODO:このページの説明文をここに記述する(※Googleの検索結果に表示されるのでよく考える事!)"}},"label":{"deadline":"申込締切","period":"期間","days":"実施日数","days_data":"%{days}日間","location":"場所","details":"内容","head_office":"本社"}}}')
  delete Component.options._Ctor
}
